import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CaretIcon, LargeExclamationMarkIcon, MutedCameraIcon, MutedMicrophoneIcon, UnmutedCameraIcon, UnmutedMicrophoneIcon, } from '@streamr/tv-ui';
import { useRef } from 'react';
import styled from 'styled-components';
function DeviceButton({ kind, muted: mutedProp, onSelectClick, onMuteClick, children, devicePresent, }) {
    const buttonRef = useRef(null);
    const muted = !devicePresent || mutedProp;
    return (_jsxs(DoubleButtonWrap, { children: [_jsx(UnderneathButton, { disabled: !devicePresent, type: "button", ref: buttonRef, onClick: () => {
                    onSelectClick(buttonRef);
                }, children: _jsx(CaretIcon, {}) }), _jsxs(TopButton, { type: "button", "data-testid": `${kind}-mute-button`, "$muted": muted, onClick: () => {
                    if (devicePresent) {
                        onMuteClick();
                    }
                    else {
                        onSelectClick(buttonRef);
                    }
                }, children: [children, !devicePresent && (_jsx(NoDeviceIconWrap, { title: `No ${kind === 'audio' ? 'microphone' : 'camera'} found`, children: _jsx(LargeExclamationMarkIcon, {}) }))] })] }));
}
export function AudioDeviceButton({ devicePresent, muted, onMuteClick, onSelectClick, }) {
    return (_jsx(DeviceButton, { devicePresent: devicePresent, kind: "audio", muted: muted, onMuteClick: onMuteClick, onSelectClick: onSelectClick, children: !devicePresent || muted ? (_jsx(MutedMicrophoneIcon, { size: "x1" })) : (_jsx(UnmutedMicrophoneIcon, { size: "x1" })) }));
}
export function VideoDeviceButton({ devicePresent, muted, onMuteClick, onSelectClick, }) {
    return (_jsx(DeviceButton, { devicePresent: devicePresent, kind: "video", muted: muted, onMuteClick: onMuteClick, onSelectClick: onSelectClick, children: !devicePresent || muted ? (_jsx(MutedCameraIcon, { size: "x1_5" })) : (_jsx(UnmutedCameraIcon, { size: "x1_5" })) }));
}
const NoDeviceIconWrap = styled.div `
    position: absolute;
    right: 0;
    top: 0;

    svg {
        position: relative;
        z-index: 1;
    }

    &::before {
        background-color: #ffffff;
        border-radius: 50%;
        content: '';
        height: 75%;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%,-50%);
        width: 75%;
    }
`;
const TopButton = styled(Button) `
    height: 3rem;
    min-width: 3rem;
    --Button_Background: ${({ $muted }) => ($muted ? 'var(--tv-ui-color-3)' : 'var(--DeviceButton_TopBackground, var(--tv-ui-color-12))')};
    --Button_HoverBackground: ${({ $muted }) => ($muted ? 'var(--tv-ui-color-3)' : 'var(--DeviceButton_TopBackground, var(--tv-ui-color-12))')};
    transform-origin: center;
    border-radius: 1.5rem;
    backdrop-filter: blur(10px);
    will-change: transform;
`;
const UnderneathButton = styled.button `
    appearance: none;
    width: 100%;
    height: 3rem;
    border: 0;
    border-radius: 1.5rem;
    padding: 0;
    padding-left: 0.375rem;
    background: var(--DeviceButton_UnderneathBackground, var(--tv-ui-color-17));
    align-items: center;
    backdrop-filter: blur(10px);

    &:disabled svg {
        opacity: 0.5;
    }
`;
const DoubleButtonWrap = styled.div `
    position: relative;
    width: 3rem;

    ${UnderneathButton} {
        display: none;
    }

    @media (min-width: 20rem) {
        min-width: 4.75rem;

        ${TopButton} {
            position: absolute;
            top: 0;
            right: 0;
        }

        ${UnderneathButton} {
            display: flex;
        }
    }
`;
